import React from 'react';
import { PrimaryButton, Stack } from '@fluentui/react';
import { PageHeading } from '../../components/common/pageHeading';
import { SettingsPanel } from '../../components/settings/settingsPanel';
import { appStyles } from '../../helpers';
import { useAppDispatch, useAppSelector } from '../../store';
import { selectTranslate } from '../../store/selectors/ui';
import { selectUser } from '../../store/selectors/auth';
import { history } from '../../helpers/history';
import { authActions } from '../../store/actions/auth/actions';

export const SettingsRootSection = () => {
    const dispatch = useAppDispatch();
    const translate = useAppSelector(selectTranslate);
    const user = useAppSelector(selectUser);

    const onRefresh = () => {
        dispatch(authActions.refreshUserConfiguration(user));
    };

    return (
        <>
            <PageHeading
                text={translate('settings_header')}
                containerStyle={{ textAlign: 'center' }}
            />
            <Stack tokens={{ childrenGap: 8 }}>
                <SettingsPanel
                    title={translate('settings_account')}
                    onClick={() => history.push('/settings/license')}
                />
                <SettingsPanel
                    title={translate('settings_general')}
                    onClick={() => history.push('/settings/general')}
                />
            </Stack>
            <Stack horizontal horizontalAlign="center">
                <PrimaryButton
                    styles={appStyles.primaryButton}
                    style={{
                        alignSelf: 'center',
                        marginTop: 20,
                        width: 200,
                    }}
                    text={translate('settings_refresh')}
                    onClick={onRefresh}
                />
            </Stack>
        </>
    );
};
